import { Table } from 'antd';
import { ErrorMessages } from 'app/lib/AppErrors';
import Button from 'components/shared/app/Button';
import Dropdown from 'components/shared/app/Dropdown';
import { useScrollDirection } from 'components/shared/app/hooks/useScrollDirection';
import Modal from 'components/shared/app/Modal';
import Config from 'lib/Config';
import Constants from 'lib/Constants';
import { getInnerError, renderError, renderLoader, renderNoDataMessage } from 'lib/utils/adaya/AdayaUtils';
import { createIsoTimeRange } from 'lib/utils/DateUtils';
import { getBrowserDimensions, throttle } from 'lib/utils/UiUtils';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import TrackingService from 'services/tracking/TrackingService';
import LocalStorage from 'utils/LocalStorage';
import { dataColumns, eventOptions, timeRangeOptions } from '../AdsManager/config';
import './style.scss';

// calculate stats from all events:
// let eventCounts = {
//     'pageview': 0,
//     'add-to-cart': 0,
//     'checkout': 0,
//     'purchase': 0,
//     'purchase (events)': purchaseEvents.length,
//     'error': 0
// };
// let totalPurchases = 0;
// let totalUniquePurchases = 0;
// let totalRevenue = 0;
// let totalPurchaseEventsRevenue = purchaseEvents.filter(p => p.price != undefined).map(p => p.price).reduce((p, c) => {
//     return p + c;
// }, 0);

// events.forEach(e => {
//     eventCounts[e.event] = (eventCounts[e.event] || 0) + 1;

//     if (e.event == 'purchase') {
//         totalRevenue += parseFloat(e.price);
//         let data = JSON.parse(e.data);
//         totalUniquePurchases++;
//         totalPurchases += data.items.reduce((acc, item) => {
//             return parseFloat(acc) + parseFloat(item.quantity);
//         }, 0)
//     }
// });

// const stats = {
//     eventCounts,
//     totalPurchases,
//     totalUniquePurchases,
//     totalRevenue,
//     totalPurchaseEventsRevenue
// }


const TrackingEvents = (props) => {
    const [showTrackingIdSection, setShowTrackingIdSection] = useState(false);
    const [accounts, setAccounts] = useState([]);
    const [selectedAccount, setSelectedAccount] = useState();
    const [selectedEvent, setSelectedEvent] = useState('all');
    const [selectedTimeFrame, setSelectedTimeFrame] = useState('today');
    const [trackingId, setTrackingId] = useState();
    const [eventData, setEventData] = useState();
    const [purchaseEventData, setPurchaseEventData] = useState();
    const [eventStats, setEventStats] = useState();
    const [formattedData, setFormattedData] = useState(undefined);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(undefined);
    const [showColumns, setShowColumns] = useState([]);
    const [editShowColumns, setEditShowColumns] = useState([]);
    const [showConfig, setShowConfig] = useState(false);
    const [filterOptions, setFilterOptions] = useState([]);
    const [filterValues, setFilterValues] = useState([]);
    const [showTable, setShowTable] = useState(false);
    const [pageSize, setPageSize] = useState(Config.ADMIN_TABLE_PAGE_SIZE);
    const [noData, setNoData] = useState(false);
    const [timeRange, setTimeRange] = useState(createIsoTimeRange('today'));
    const { x, y } = getBrowserDimensions();
    const user = props.auth.user;

    const updateData = async (useCache = true) => {
        try {
            setError(undefined);
            setLoading(true);

            let filter = { event: selectedEvent, ...filterValues };
            if (timeRange.start_date || timeRange.end_date) {
                filter.timeRange = { start_date: timeRange.start_date, end_date: timeRange.end_date };
            }

            let data = await Promise.all([
                TrackingService.getEvents(trackingId, filter, selectedTimeFrame != 'today' && useCache),
                TrackingService.getPurchaseEvents(trackingId, filter, selectedTimeFrame != 'today' && useCache),
                TrackingService.getEventStatsByCampaign(trackingId, filter, selectedTimeFrame != 'today' && useCache)
            ]);

            let ed = data[0];
            let ped = data[1];
            let ec = data[2];

            // extract date value from bigquery format
            ed.forEach(e => e.date = e.date.value);

            let eventStats = {
                eventCounts: ec,
                purchaseStats: calculatePurchaseStats(ped)
            }

            setEventData(ed);
            setPurchaseEventData(ped);
            setEventStats(eventStats);
            setFilterOptions([]);
            setShowTable(true);
        } catch (e) {
            setError(getInnerError(e));
        }

        setLoading(false);
    }

    const calculatePurchaseStats = (purchaseEvents) => {
        let totalRevenue = 0;
        let totalPurchases = 0;
        let totalUniquePurchases = purchaseEvents.length;

        purchaseEvents.forEach(p => {
            if (p.price == undefined) return;
            totalRevenue += p.price;
            if (p.items) {
                totalPurchases += p.items.reduce((acc, item) => {
                    return parseFloat(acc) + parseFloat(item.quantity);
                }, 0)
            }
        });

        return {
            totalRevenue,
            totalPurchases,
            totalUniquePurchases
        }
    }

    useEffect(() => {
        let sc = LocalStorage.get(Constants.USERPREF_TRACKING_COLS);
        if (sc) {
            setShowColumns(sc);
        } else {
            setShowColumns(dataColumns.map(d => d));
        }
    }, []);

    // recalculate totals from changed data
    // useEffect(() => {
    // }, [eventData, purchaseEventData, eventStats]);

    // update selected account
    useEffect(async () => {
        if (props.auth.user) {
            if (props.auth.user.roles.includes('admin')) {
                let accounts = await TrackingService.getAllAccounts();
                let unique = [];
                accounts = accounts.filter(a => a.activeAccount != undefined).map(a => a.activeAccount).filter(a => {
                    if (!unique.find(u => u._id == a._id)) {
                        unique.push(a);
                        return true;
                    }
                    return false;
                });
                setAccounts(unique);
            } else if (props.auth.user.accounts) {
                setAccounts(props.auth.user.accounts);
            }

            if (props.auth.user.activeAccount) {
                setSelectedAccount(props.auth.user.activeAccount);
                if (!props.auth.user.activeAccount.tracking || !props.auth.user.activeAccount.tracking.trackingId) {
                    setShowTrackingIdSection(true);
                }
            }
        }
    }, [props.auth.user]);

    // update/get report data
    useEffect(() => {
        (async () => {
            if (trackingId) {
                updateData();
                setNoData(false);
            } else {
                setNoData(true);
            }
        })();
    }, [selectedEvent, selectedTimeFrame, trackingId])

    // helper to keep tracking of current tracking id
    useEffect(() => {
        if (selectedAccount && selectedAccount.tracking) {
            setTrackingId(selectedAccount.tracking.trackingId);
        } else {
            setTrackingId(null);
        }
    }, [selectedAccount]);

    const onSelectedAccountChange = (v) => {
        setSelectedAccount(accounts.find(a => a._id == v));
    }

    const onChangeTimeFrame = async (value) => {
        let timeRange = createIsoTimeRange(value);
        setSelectedTimeFrame(value);
        setTimeRange(timeRange);
    }

    const onChangeEvent = async (value) => {
        setSelectedEvent(value);
    }

    const setFilterItem = (col, v) => {
        let fo: [] = filterValues;
        if (v == 'all') {
            delete fo[col];
        } else {
            fo[col] = v;
        }
        setFilterValues(fo);
        updateData();
    }

    const filterTextChanged = (col, e) => {
        let fo: [] = filterValues;
        filterValues[col] = e.target.value;
        setFilterValues(fo);
        updateData();
    }

    const generateFilters = () => {
        let filters = [
            <div className="control filter-timeframe" key="time">
                <div className="control-label">Time frame:</div>
                <Dropdown className="white"
                    selectedItem={selectedTimeFrame}
                    setSelection={onChangeTimeFrame}
                    items={timeRangeOptions}
                />
            </div>,

            <div className="control filter-events" key="events">
                <div className="control-label">Events:</div>
                <Dropdown className="white"
                    selectedItem={selectedEvent}
                    setSelection={onChangeEvent}
                    items={eventOptions}
                />
            </div>,
        ]

        dataColumns.forEach(colConfig => {
            let col = colConfig.key;// sc.key;
            //let colConfig = dataColumns.find(d => d.key == col);
            if (colConfig && colConfig.showFilter) {
                if (colConfig.key == 'event') return; // skip events, already added manually.

                if (colConfig.filterType && ['text', 'number'].includes(colConfig.filterType)) {
                    filters.push(
                        <div className={`control filter-${col}`} key={`${col}`}>
                            <div className="control-label">{colConfig.title}:</div>
                            <input type="text" onChange={throttle((e) => { filterTextChanged(col, e) }, 1000)} />
                        </div>
                    )
                } else {
                    let opts = [{ label: 'All', value: 'all' }];
                    let selectedItem = filterValues[col] || 'all';

                    // only generate options on first load (todo: must reset on new paged data, or get full option set from server...)
                    if (filterOptions[col]) {
                        opts = filterOptions[col];
                    } else {
                        let vals = ['all'];
                        // get all possible values for this filter:
                        if (eventData) {
                            eventData.forEach(d => {
                                let v = d[col];
                                if (v && !vals.includes(v)) {
                                    vals.push(v);
                                    opts.push({ label: v, value: v });
                                }
                            });

                            if (col && opts.length) {
                                let fo = filterOptions;
                                fo[col] = opts;
                                setFilterOptions(fo);
                            }
                        }
                    }

                    filters.push(
                        <div className={`control filter-${col}`} key={`${col}`}>
                            <div className="control-label">{colConfig.title}:</div>
                            <Dropdown className="white"
                                setFixedWidth={false}
                                selectedItem={selectedItem}
                                setSelection={v => setFilterItem(col, v)}
                                items={opts}
                            />
                        </div>
                    )
                }
            }
        });

        return filters;
    }

    const saveConfig = () => {
        const sc = editShowColumns.map(c => c);
        setShowColumns(sc);
        setShowConfig(false);
        LocalStorage.set(Constants.USERPREF_TRACKING_COLS, sc);
    }

    const onShowColumnChange = (col, val) => {
        let sc: [] = editShowColumns;

        let idx = editShowColumns.findIndex(c => c.key == col);
        if (idx >= 0) {
            sc.splice(idx, 1);
        } else {
            let idx = dataColumns.findIndex(c => c.key == col);
            sc.push(dataColumns[idx]);
        }

        // order based on dataColumns:
        let ac = [];
        dataColumns.forEach(d => {
            if (sc.find(c => c.key == d.key) != null) {
                ac.push(d);
            }
        });

        setEditShowColumns(ac);
    }

    const selectAllColumns = () => {
        setEditShowColumns(dataColumns.map(d => d));
    }

    // force header to top when near top
    let scroll = useScrollDirection(document.getElementById('app'));
    if (scroll.scrollTop < y / 4) {
        scroll.direction = 'down';
    }

    const generateColumns = () => {
        return dataColumns.filter(dc => showColumns.find(sc => sc.key == dc.key) != null);
    }

    const onTableChange = (pagination, filters, sorter, extra) => {
        setPageSize(pagination.pageSize);
    }

    return (
        <div id="tracking-events-page" className={'page-layout ' + (scroll.direction == 'up' ? 'show-menu' : '')}>

            {selectedAccount ? (

                <div className="tracking-content page-content">

                    <div className="page-header">
                        <div className="account-header">
                            <div className="title pad md">TRACKING{selectedAccount && ` - ${selectedAccount.name}`}</div>

                            <div className="controls flex-row flex-center-y flex-end">
                                <h6 className="pad sm ntb">Account:</h6>

                                {user && <Dropdown className="white" setFixedWidth={false}
                                    selectedItem={selectedAccount.name || null}
                                    setSelection={onSelectedAccountChange}
                                    items={accounts.map(a => { return { value: a._id, label: a.name } })}
                                />}

                                {selectedAccount.tracking &&
                                    <div className="tracking-id pad md ntb">
                                        <h6>Tracking ID:</h6>
                                        <span>{trackingId}</span>
                                    </div>
                                }

                                <Link to="/account" className="margin md ntb"><Button round color="white">Go to Account</Button></Link>
                            </div>
                        </div>

                        <div className="filter pad sm ntb flex-row">

                            <div className="col left flex-row-center-y">
                                <h6>Filter:</h6>

                                <div className="control refresh">
                                    <Button icon round color="white" onClick={updateData}>&#8635;</Button>
                                </div>

                                {generateFilters()}

                                <Button className="flex-end" round color="white" onClick={() => { setShowConfig(true); setEditShowColumns(showColumns.map(c => c)); }}>Config</Button>

                            </div>

                            {showConfig &&
                                <Modal active={showConfig} toggleActive={() => setShowConfig(false)}>
                                    <div className="tracking-modal-config flex-col">
                                        <h6>Choose columns to show:</h6>
                                        <div className="choose-columns margin md ns">
                                            {dataColumns.map(c => {
                                                return <div className="row" key={c.key}>
                                                    <input type="checkbox" id={`cb-${c.key}`}
                                                        checked={editShowColumns.find(_c => _c.key == c.key) != null}
                                                        onChange={(e) => {
                                                            onShowColumnChange(c.key, e.target.value);
                                                        }}
                                                    />
                                                    <label htmlFor={`cb-${c.key}`}>{c.title}</label>
                                                </div>
                                            })}
                                        </div>

                                        <Button className="flex-inline select-all" size="small" round filled color="blue" onClick={() => selectAllColumns()}>Select All</Button>

                                        <div className="actions flex-row margin sm ns space">
                                            <Button round color="blue" onClick={() => setShowConfig(false)}>Cancel</Button>
                                            <Button round filled color="blue" onClick={saveConfig}>Save</Button>
                                        </div>
                                    </div>
                                </Modal>
                            }

                        </div>
                    </div>

                    <div className="report" id="ReportData">

                        {loading && renderLoader()}

                        {error && renderError(ErrorMessages.defaultErrorMessage(), error, "large")}

                        {noData && renderNoDataMessage()}

                        {!noData && eventStats && !error &&
                            <div className="event-stats flex-center-y">

                                <div className="stat-item">
                                    <div className="label">
                                        Events <b className="total-events">({eventData.length})</b>:
                                    </div>
                                    {/* <div className="value">
                                                {eventStats.eventCounts.map(es => {
                                                    return (
                                                        <div className="item" key={es.event}>
                                                            <span className="ec-label">{es.event}: </span>
                                                            <span className="ec-count">{es.count}</span>
                                                        </div>
                                                    )
                                                })}
                                            </div> */}
                                </div>
                                {/*
                                        <div className="stat-item">
                                            <div className="label">
                                                Purchases
                                            </div>
                                            <div className="value">
                                                {eventStats.purchaseStats.totalPurchases}
                                            </div>
                                        </div>

                                        <div className="stat-item">
                                            <div className="label">
                                                Unique Purchases
                                            </div>
                                            <div className="value">
                                                {eventStats.purchaseStats.totalUniquePurchases}
                                            </div>
                                        </div>

                                        <div className="stat-item">
                                            <div className="label">
                                                Total Revenue:
                                            </div>
                                            <div className="value">
                                                {formatCurrency(eventStats.purchaseStats.totalRevenue, 2)}
                                            </div>
                                        </div>

                                        <div className="stat-item">
                                            <div className="label">
                                                AOV:
                                            </div>
                                            <div className="value">
                                                {formatCurrency(orZero((eventStats.totalRevenue / eventStats.purchaseStats.totalUniquePurchases)), 2)}
                                            </div>
                                        </div> */}

                            </div>
                        }

                        {showTable && eventData && !error &&
                            <Table
                                pagination={{ pageSize: pageSize, position: ["bottomLeft"] }}
                                rowKey={(entity: any) => `te-${entity.event}-${entity.date}-${entity.client_fingerprint}`}
                                dataSource={eventData} columns={generateColumns()}
                                onChange={onTableChange}
                            />
                        }

                    </div>

                </div>

            ) : 'No user loaded.'}

        </div>

    );

}

export default TrackingEvents;